/* src/app/components/eb/eb.component.scss */
.close {
  position: absolute;
  top: 10px;
  right: 10px;
}
::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {
  overflow: hidden !important;
}
/*# sourceMappingURL=eb.component-25PNZEKT.css.map */
